import { ClientActionType } from '../../actions/client.actions';
import { Actions } from '../../actions/index';
import { OrganizationHelpers } from '@mode/legacy/data-access-model-js';
import { AvatarTypes } from '@mode/shared/contract-common';

export const initialOrgAvatarState: AvatarTypes.ReportContextAvatar = {
  type: null,
  name: null,
  targetUrl: '#',
  initials: null,
  imageSrc: null,
  colorClass: null,
};

function typeReducer(state = initialOrgAvatarState.type, action: Actions) {
  switch (action.type) {
    case ClientActionType.LoadReportContext: {
      // if user indicates this owner is a community account
      if (OrganizationHelpers.isCommunityOrg(action.organization)) {
        return AvatarTypes.AvatarType.Community;
      } else {
        return action.organization.avatar.type;
      }
    }
  }

  return state;
}

function nameReducer(state = initialOrgAvatarState.name, action: Actions) {
  switch (action.type) {
    case ClientActionType.LoadReportContext:
      return action.organization.name;
  }

  return state;
}

export function targetUrlReducer(state = initialOrgAvatarState.targetUrl, action: Actions) {
  switch (action.type) {
    case ClientActionType.ComputeIfUserBelongsToReportContext:
      const belongsToReportContext = action.result;

      if (action.homeLink && belongsToReportContext) {
        return action.homeLink;
      } else {
        return '';
      }
  }

  return state;
}

function initialsReducer(state = initialOrgAvatarState.initials, action: Actions) {
  switch (action.type) {
    case ClientActionType.LoadReportContext: {
      if (action.organization.avatar.type === AvatarTypes.AvatarType.Initials) {
        return action.organization.avatar.initials;
      }
    }
  }

  return state;
}

function imageSrcReducer(state = initialOrgAvatarState.imageSrc, action: Actions) {
  switch (action.type) {
    case ClientActionType.LoadReportContext: {
      switch (action.organization.avatar.type) {
        case AvatarTypes.AvatarType.Uploaded:
        // fallthrough
        case AvatarTypes.AvatarType.Gravatar:
          return action.organization.avatar.href;
      }
    }
  }

  return state;
}

function colorClassReducer(state = initialOrgAvatarState.colorClass, action: Actions) {
  switch (action.type) {
    case ClientActionType.LoadReportContext: {
      if (action.organization.avatar.type === AvatarTypes.AvatarType.Initials) {
        return action.organization.avatar.color_class;
      }
    }
  }

  return state;
}

export const ReportContextAvatarReducer = {
  type: typeReducer,
  name: nameReducer,
  targetUrl: targetUrlReducer,
  initials: initialsReducer,
  imageSrc: imageSrcReducer,
  colorClass: colorClassReducer,
};
